<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard no-header>
        <CCardBody>
          <CInput readonly :label="$t('fields.name')" type="text" :placeholder="$t('fields.expense_type_placeholder')" v-model="expenseType.name"></CInput>
          <CButton v-if="permissions.expense_types.edit" color="success" @click="editExpenseType()">
              <CIcon :content="$options.editIcon" /> {{ $t('button.edit') }}
              </CButton>
            <CButton color="primary" @click="goBack"><CIcon :content="$options.backIcon" /> {{ $t('button.back') }}</CButton>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import formMixin from "../../mixins/form";
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilPencil, cilArrowLeft } from '@coreui/icons';

export default {
  name: 'ExpenseType',
  mixins: [formMixin, localeMixin],
  editIcon: cilPencil,
  backIcon: cilArrowLeft,
  data() {
    return {
      expenseType: {
        name: ''
      },
    }
  },
  mounted() {
    const id = this.$route.params.id;
    axios.get('/api/expense-types/' + id + '?token=' + localStorage.getItem("api_token"))
    .then(response => {
      this.expenseType = response.data;
    }).catch(error => {
      console.log(error);
      this.$router.push({ path: '/login' });
    });
  },
  methods: {
    goBack() {
      this.$router.push({ name: "ExpenseTypes" });
    },
    editExpense() {
      const id = this.$route.params.id;
      this.$router.push({ name: 'EditExpenseType', params: {id} })
    }
  }
}


</script>
